import Sharer from 'sharer.js';

import Nav from './components/nav';
import Slider from './components/swiper';
import slab_Masonry from './components/masonry';
import Selects from './components/selects';
import Accordions from './components/accordions';
import Forms from './components/forms';

import './components/script.js';
import './woo/woo-quantity.js';

const initScripts = () => {
    new Nav();
    new Slider();
    new slab_Masonry();
    new Selects();
    new Accordions();
    new Forms();
}

document.addEventListener("DOMContentLoaded", function () {
    initScripts();
});

